/**
 * `react-native-performance` is a native implementation of `performance` Web API.
 * @see https://github.com/oblador/react-native-performance/blob/master/packages/react-native-performance/README.md
 *
 * We can alias `react-native-performance` with the actual `performance` Web API in browsers by pointing to this file in our `webpack.config.js`
 * @see https://developer.mozilla.org/en-US/docs/Web/API/Performance
 */
export default performance;
